import Vue from "vue";
import Router from "vue-router";
import Dashboard from "./views/Dashboard.vue";
import Home from "./views/Home.vue";
import Admin from "./views/Admin.vue";
import Notifications from "./views/Notifications";
import KnowledgeBase from "./views/KnowledgeBase";
import Projects from "./views/Projects";
import Project from "./views/Project";
import Hosts from "./views/Hosts";
import Host from "./views/Host";
import About from "./views/About";
import Prospects from "./views/Prospects";
import Prospect from "./views/Prospect";
import Announcements from "./views/Announcements";
import Announcement from "./views/Announcement";
import Billing from "./views/Billing";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      meta: { layout: "empty" },
      component: Home
    },
    {
      path: "/callback-sso",
      name: "SSO",
      meta: { layout: "empty" },
      component: Home
    },
    {
      path: "/notifications",
      name: "notifications",
      meta: { section: "notifications", tab: null },
      component: Notifications
    },
    {
      path: "/admin",
      name: "admin",
      meta: { section: "admin" },
      component: Admin
    },
    {
      path: "/help",
      name: "help",
      meta: { section: "help" },
      component: KnowledgeBase
    },
    {
      path: "/about",
      name: "about",
      meta: { section: "about" },
      component: About
    },
    {
      path: "/reloc",
      name: "reloc",
      meta: { section: "projects" },
      component: Projects,
      props: { mode: "reloc" }
    },
    {
      path: "/sales",
      name: "sales",
      meta: { section: "projects" },
      component: Projects,
      props: { mode: "sale" }
    },
    {
      path: "/compta",
      name: "compta",
      meta: { section: "projects" },
      component: Projects,
      props: { mode: "compta" }
    },
    {
      path: "/prospects",
      name: "prospects",
      meta: { section: "prospects" },
      component: Prospects
    },
    {
      path: "/announcements",
      name: "announcements",
      meta: { section: "announcements", tab: 4 },
      component: Announcements
    },
    {
      path: "/announcement/:id",
      name: "announcement",
      meta: { section: "announcement", tab: 4 },
      component: Announcement
    },
    {
      path: "/billing",
      name: "billing",
      meta: { section: "billing" },
      component: Billing
    },
    {
      path: "/project/:id/:tab?/:sub_id?",
      name: "project",
      meta: { section: "projects", tab: 0 },
      component: Project
    },
    {
      path: "/prospect/:id/:tab?/:sub_id?",
      name: "prospect",
      meta: { section: "prospects", tab: 3 },
      component: Prospect
    },
    {
      path: "/hosts",
      name: "hosts",
      meta: { section: "hosts" },
      component: Hosts
    },
    {
      path: "/host/:id",
      name: "host",
      meta: { section: "hosts", tab: 2 },
      component: Host
    },
    {
      path: "/dashboard",
      name: "dashboard",
      meta: { section: "dashboard" },
      component: Dashboard
    }
  ]
});
